/**
 * Settings — accessibility/UX toggles (persisted in meta) + save management
 * (export/import the active run, wipe progress). All persistence flows through
 * the store/SaveManager.
 */

import { el, div, button } from "../dom";
import type { Store } from "../store";

export function renderSettings(store: Store): HTMLElement {
  const s = store.settings;
  const screen = div("screen");
  const body = div("screen__body scroll");

  body.appendChild(
    div("row", [
      el("div", { class: "h-title", text: "SETTINGS" }),
      div("fill"),
      button("btn btn--sm", "◀ BACK", () =>
        store.run ? store.closeOverlay() : store.open("title"),
      ),
    ]),
  );

  // Toggles.
  const panel = div("panel col");
  panel.appendChild(
    toggle("Reduced motion", s.reducedMotion, (v) =>
      store.setSetting("reducedMotion", v),
    ),
  );
  panel.appendChild(
    toggle("Show damage numbers", s.showDamageNumbers, (v) =>
      store.setSetting("showDamageNumbers", v),
    ),
  );
  panel.appendChild(
    toggle("Confirm end turn with Cycles left", s.confirmEndTurn, (v) =>
      store.setSetting("confirmEndTurn", v),
    ),
  );
  body.appendChild(panel);

  // Save management.
  body.appendChild(el("div", { class: "h-sub", text: "SAVE", style: "margin-top:8px" }));
  const savePanel = div("panel col");

  if (store.run) {
    savePanel.appendChild(
      div("row", [
        button("btn btn--sm", "⎘ EXPORT RUN", () => {
          const str = store.exportRun();
          if (str) {
            navigator.clipboard?.writeText(str).catch(() => {});
            prompt("Run save string (copied to clipboard):", str);
          }
        }),
      ]),
    );
  }
  savePanel.appendChild(
    div("row", [
      button("btn btn--sm", "⎀ IMPORT RUN", () => {
        const str = prompt("Paste a NULLRUN run save string:");
        if (str) store.importRun(str.trim());
      }),
    ]),
  );
  savePanel.appendChild(
    button("btn btn--sm btn--danger", "⌦ WIPE ALL PROGRESS", () => {
      if (
        confirm(
          "Wipe ALL meta-progression (unlocks, stats, settings)? This cannot be undone.",
        )
      ) {
        store.resetMeta();
      }
    }),
  );
  body.appendChild(savePanel);

  screen.appendChild(body);
  return screen;
}

function toggle(
  label: string,
  value: boolean,
  onChange: (v: boolean) => void,
): HTMLElement {
  const btn = button(
    value ? "btn btn--sm btn--primary" : "btn btn--sm",
    value ? "ON" : "OFF",
    () => onChange(!value),
  );
  return div("toggle", [el("span", { text: label }), btn]);
}
